import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'

import PDSBox from 'designSystem/components/PDSBox/PDSBox'
import PDSButton from 'designSystem/components/PDSButton/PDSButton'
import PDSFlexBox from 'designSystem/components/PDSFlexBox/PDSFlexBox'
import PDSHeader from 'designSystem/components/PDSHeader/PDSHeader'
import PDSSeparator from 'designSystem/components/PDSSeparator/PDSSeparator'
import PDSText from 'designSystem/components/PDSText/PDSText'
import { COLOR } from 'designSystem/foundations/constants/color'
import { SIZE } from 'designSystem/foundations/constants/size'

type Props = {
  onClose: () => void
  showModal: boolean
}

export default function AssetETFMutualFundMappingModal({
  onClose,
  showModal,
}: Props) {
  return (
    <>
      <Modal isOpen={showModal} onClose={onClose} size="lg">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader paddingTop={SIZE.s32}></ModalHeader>
          <ModalCloseButton />
          <ModalBody paddingX={SIZE.s0} paddingBottom={SIZE.s0}>
            <PDSSeparator />
            <PDSFlexBox
              backgroundColor={COLOR.backdrop}
              display="flex"
              flexDirection="column"
              gap={SIZE.s16}
              maxHeight="28rem"
              overflowY="scroll"
              paddingBottom={SIZE.s40}
              paddingTop={SIZE.s16}
              paddingX={SIZE.s16}
            >
              <PDSHeader variant="h4">
                Use of ETF mapping for Mutual Funds
              </PDSHeader>
              <PDSBox>
                <PDSText>
                  To improve the overall efficiency and performance of your
                  investment portfolio, the model may recommend replacing
                  certain mutual funds with comparable exchange-traded funds
                  (ETFs).
                </PDSText>
              </PDSBox>
              <PDSBox>
                <PDSText>This mapping is based on factors including:`</PDSText>
              </PDSBox>
              <PDSBox>
                <ul style={{ marginLeft: SIZE.s24 }}>
                  <li>
                    <PDSText>Expense ratios</PDSText>
                  </li>
                  <li>
                    <PDSText>Liquidity and bid-ask spreads</PDSText>
                  </li>
                  <li>
                    <PDSText>
                      Tax efficiency (e.g., capital gains distributions)
                    </PDSText>
                  </li>
                  <li>
                    <PDSText>Tracking error relative to target indexes</PDSText>
                  </li>
                  <li>
                    <PDSText>Portfolio allocation and diversification</PDSText>
                  </li>
                </ul>
              </PDSBox>
              <PDSBox>
                <PDSBox>
                  <PDSText weight="semibold">
                    Assumptions and Limitations:
                  </PDSText>
                </PDSBox>
                <PDSText>
                  While ETFs often provide advantages in terms of cost and tax
                  treatment, mutual funds may offer benefits in other areas,
                  such as automatic reinvestment, availability in retirement
                  plans, or dollar-cost averaging features. The optimization
                  model makes assumptions that may not account for every
                  client-specific factor, including:
                </PDSText>
              </PDSBox>
              <PDSBox>
                <ul style={{ marginLeft: SIZE.s24 }}>
                  <li>
                    <PDSText>Legacy holdings or embedded capital gains</PDSText>
                  </li>
                  <li>
                    <PDSText>
                      Fund availability in certain account types
                    </PDSText>
                  </li>
                  <li>
                    <PDSText>
                      Transaction costs, loads, or platform restrictions
                    </PDSText>
                  </li>
                </ul>
              </PDSBox>
              <PDSBox>
                <PDSBox>
                  <PDSText weight="semibold">
                    Client-Specific Customization:
                  </PDSText>
                </PDSBox>
                <PDSText>
                  You are not required to implement these recommendations as-is.
                  Your financial professional should review any proposed changes
                  with you to ensure they align with your goals, risk tolerance,
                  and constraints.
                </PDSText>
              </PDSBox>
              <PDSBox>
                <PDSBox>
                  <PDSText weight="semibold">
                    Conflict of Interest Disclosure:
                  </PDSText>
                </PDSBox>
                <PDSText>
                  We do not receive compensation from ETF or mutual fund
                  providers for using or recommending their products. All
                  recommendations are made in accordance with our fiduciary duty
                  to act in your best interest.
                </PDSText>
              </PDSBox>
            </PDSFlexBox>
          </ModalBody>
          <PDSSeparator />
          <ModalFooter paddingTop={SIZE.s12}>
            <PDSFlexBox width="100%" margin={SIZE.s16}>
              <PDSButton
                onClick={onClose}
                size="md-f"
                text="Close"
                variant="tertiary"
              />
            </PDSFlexBox>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
